import { FeedbackDialog } from '@/components/form/feedback-dialog'
import { useClientContext } from '@/context/client'


export function FeedbackDialogWrapper() {
  const { isDialogOpen, setIsDialogOpen, message } = useClientContext()

  return <FeedbackDialog isOpen={isDialogOpen} onOpenChange={setIsDialogOpen} message={message} />
}
